import KeyedDto from '../KeyedDto';
import NamedDto from '../NamedDto';

export default class AccessConfigUserDto extends NamedDto {
	constructor() {
		super();
		/** @type {KeyedDto} */
		this.profilePicture = null;
	}

	/**
	 * @typedef {Object} _AccessConfigUserDtoProps
	 * @property {KeyedDto} profilePicture
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AccessConfigUserDtoProps} AccessConfigUserDtoProps
	 */
	/**
	 *
	 * @param {AccessConfigUserDtoProps} props
	 * @returns {AccessConfigUserDto}
	 */
	setup(props) {
		super.setup(props);
		this.profilePicture = props.profilePicture;
		return this;
	}
}
